import React from 'react';
import { usePermissionsContext } from '../context/permissions-context';
import Page403 from 'components/pages/403';

interface RoutePermissionGuardProps {
  children: React.ReactNode;
  permissionSlug: string;
  entryPoint?: string;
  groupName?: string;
  action?: string;
}

export const RoutePermissionGuard: React.FC<RoutePermissionGuardProps> = ({
  children,
  permissionSlug,
  entryPoint,
  groupName,
  action,
}) => {
  const { hasPermission, isDeveloper } = usePermissionsContext();

  // Check access rights
  const hasAccess = isDeveloper || hasPermission(permissionSlug, entryPoint, groupName, action);

  if (!hasAccess) {
    return <Page403 />;
  }

  return <>{children}</>;
};